/**
 * 全站http配置
 *
 * header参数说明
 * serialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios'

axios.defaults.baseURL = 'https://write.inooy.cn';
axios.defaults.timeout = 25000;
//返回其他状态吗
axios.defaults.validateStatus = function(status) {
    return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

//HTTPRequest拦截
axios.interceptors.request.use(config => {
    //const isToken = (config.data || {}).isToken === false
    // let token = store.state.user.accessToken
    // if (token && !isToken) {
    //     config.headers['token'] = token // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    // }
    return config
}, error => {
    return Promise.reject(error)
});
//HTTPResponse拦截
axios.interceptors.response.use(res => {
    const status = Number(res.status) || 200;
    const message = res.data.msg || '未知错误';
    //如果请求为200则放过，否者默认统一处理,或者在website中配置statusWhiteList白名单自行处理
    // 401  access_token错误，先尝试用refresh_token刷新

    console.log("进入结果拦截器：");
    if (status !== 200) {

        return Promise.reject(new Error(message))
    }
    return res;
}, error => {
    console.log(error);
    return Promise.reject(new Error(error));
});

export default axios;
